import { ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorDialogComponent } from '../error_dialog/error_dialog.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TextFieldModule } from '@angular/cdk/text-field';
//import { MaterialFileInputModule } from 'ngx-material-file-input';

@Component({
  selector: 'basic_dialog',
  standalone: true,
  templateUrl: './basic_dialog.component.html',
  styleUrls: ['./basic_dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TextFieldModule,
    //MaterialFileInputModule
  ]
})
export class BasicDialogComponent {
  title: string;
  content: string;
  buttons: any[];

  inputs: any[];
  form: FormGroup = new FormGroup({});
  selectedFile: File | null = null;
  idDocument: string;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _dialogRef: MatDialogRef<BasicDialogComponent>,
    private _dialog: MatDialog
  ) {
    this.title = data.title;
    this.content = data.content;
    this.buttons = this.mapButtons(data.buttons);
    this._dialogRef.addPanelClass('basic-dialog-panel');

    this.inputs = data.inputs;
    if (this.inputs) {
      this.form = this.createForm(this.inputs);
    }
  }

  /**
   * On init
   */
  ngOnInit(): void { }

  mapButtons(buttonsConfig: any[]) {
    return buttonsConfig.map(button => {
      return {
        label: button.label,
        action: this.getAction(button.action),
        class: this.getButtonClass(button.action)
      };
    });
  }

  getAction(action: string) {
    const actions: any = {
      'cancel': this.close.bind(this),
      'yes': this.yesClick.bind(this)
    };

    return actions[action];
  }

  getButtonClass(action: string) {
    const buttonClass: any = {
      'cancel': 'btn-cancel',
      'yes': 'btn-confirm'
    };

    return buttonClass[action];
  }

  createForm(inputs: any) {
    inputs.forEach(input => {
      const validators = input.checkPassword ? input?.validators ? [...input.validators, this.notMatchPassword(input.matchInput)] : [this.notMatchPassword(input.matchInput)] : input.validators || [];
      this.form.addControl(input.id, new FormControl({value: input.value || '', disabled: input?.disabled || false}, validators));
    });

    return this.form;
  }

  onFileSelected(event: Event, input: any) {
    const allowedMimeTypes = [
      'image/jpg',
      'image/jpeg',
      'image/png',
      'application/pdf',
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.oasis.opendocument.text', // .odt
      'application/vnd.oasis.opendocument.spreadsheet', // .ods
      'application/zip',
      'application/x-zip-compressed',
      'application/x-7z-compressed' // .7z
    ];

    const target = event.target as HTMLInputElement | null;
    this.selectedFile = target?.files?.[0] ?? null;
    this.idDocument = input.id;

    if (this.selectedFile && !allowedMimeTypes.includes(this.selectedFile.type)) {
      const errorMsg = `<span class="flex flex-col gap-6"><span>File type not allowed:</span><span>Allowed files: <br> ${input.accept}</span></span>`;

      const dialogRef = this._dialog.open(ErrorDialogComponent, {
        autoFocus: false,
        panelClass: 'no-padding-dialog',
        data: {
          title: 'File not allowed',
          content: errorMsg,
          buttons: [{ label: 'OK', action: 'ok' }]
        }
      });

      dialogRef.afterClosed().subscribe(() => {
        this.selectedFile = null;
        this.createForm(this.inputs);
        this.form.controls[input.id].setValue('');
        if (this.form.controls[input.id].hasError('required')) {
          this.form.controls[input.id].setErrors({ required: true });
        }
      });
    }

    if (this.selectedFile) {
      this.form.controls[input.id].setErrors(null);
    } else {
      this.form.controls[input.id].setValue('');
      if (this.form.controls[input.id].hasError('required')) {
        this.form.controls[input.id].setErrors({ required: true });
      }
    }
  }

  yesClick() {
    if (this.form) {
      if (this.form.valid) {
        if (this.selectedFile)
          this.form.controls[this.idDocument].setValue(this.selectedFile);

        this._dialogRef.close({
          return: 'success',
          form: this.form
        });
      } else {
        this.form.markAllAsTouched();
        return;
      }
    } else {
      this._dialogRef.close({ return: 'success' });
    }
  }

  notMatchPassword(matchInput): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const originalPassword = this.form.get(matchInput).value;
  
      return originalPassword && control.value && (originalPassword != control.value) 
        ? { 'notMatch': true }
        : null;
    };
  }

  close(): void {
    this._dialogRef.close({ return: '' });
  }
}
